export const SDK_VERSION = '3.6.0';
